module.exports = __webpack_public_path__ + "media/images/registrations/product_version/bg-07-e6a964a24a7bf72c785aa94ab2325d2a.png";